<template>
  <component :is="tagName" :href="data.link_url" class="cube-entry">
    <div class="image-block">
      <van-image :src="data.image_url" fit="cover"/>
    </div>
  </component>
</template>

<script>
  export default {
	name: 'CubeEntry',
	props: {
	  image_url: String,
	  data: Object
	},
	computed: {
	  tagName() {
		return this.$IS_PREVIEW ? 'div' : 'a';
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .cube-entry {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    .image-block {
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      .van-image {
        display: block;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
      }
    }
  }
</style>
